import React from 'react';

const MinusIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 8a.617.617 0 0 1-.615.615h-6.77v6.77a.615.615 0 1 1-1.23 0v-6.77H.615a.615.615 0 1 1 0-1.23h6.77V.614a.615.615 0 1 1 1.23 0v6.77h6.77c.338 0 .615.276.615.615z"
        fill="currentColor"
        strokeWidth="0"
      />
    </svg>
  );
};

export default MinusIcon;
